import { RelatedAccount } from './account.domain';

export enum Currency {
  CAD = 'CAD',
  USD = 'USD'
}

export enum MarketType {
  CA = 'CA',
  US = 'US',
  OTHER = 'OTHER' // mutual funds and fixed income
}

export type MarketTemplateType = `${MarketType}`;

export class MarketTypeHelper {
  static fromString(str: string): MarketType {
    if (str === undefined ) {
      return undefined;
    }
    if (str.toUpperCase() === 'CA') {
      return MarketType.CA;
    }
    if (str.toUpperCase() === 'US') {
      return MarketType.US;
    }
    if (str.toUpperCase() === 'OTHER') {
      return MarketType.OTHER;
    }
  }
}

export enum MarketExchangeType {
  UNKNOWN = 'UNKNOWN',
  TORONTO = 'TORONTO',
  CANADIAN = 'CANADIAN',
  MONTREAL = 'MONTREAL',
  VANCOUVER = 'VANCOUVER',
  NEW_YORK = 'NEW_YORK',
  NASDAQ = 'NASDAQ',
  AMEX = 'AMEX',
  US_COMPOSITE = 'US_COMPOSITE',
  MUTUAL_FUNDS = 'MUTUAL_FUNDS',
  OPRA = 'OPRA',
  WINNIPEG = 'WINNIPEG',
  ALBERTA = 'ALBERTA',
  GIC = 'GIC',
  CSE = 'CSE',
  NEO = 'NEO'
}

export type DividendType = 'MARKET' | 'TREASURY';

export type DividendStatus = 'AS_CASH' | 'REINVESTING';

export interface Dividend {
  amountLast?: number;
  amountNext?: number;
  currencyCode?: string;
  dividendDate?: Date;
  exDate?: Date;
  frequency?: string;
  yield?: number;
  dividendType?: DividendType;
  dividendStatus?: DividendStatus;
  relatedAccounts?: Array<RelatedAccount>;
}
